{
  "eyebrow": "Confirm your plan",
  "title": "Review and configure.",
  "sub": "You can change billing cycle or switch plans within your product line anytime from your admin dashboard. Moving between Time and Project is arranged with our team.",
  "yourPlan": "Your plan",
  "changePlan": "Change plan",
  "billing": "Billing cycle",
  "billingMonthLabel": "Pay monthly",
  "billingMonthDesc": "Flexible. Cancel anytime.",
  "billingYearLabel": "Pay annually",
  "billingYearDesc": "15% off. Billed once a year.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Social security (check-in/out@work)",
    "ssecDesc": "Belgium only — automatic Dimona declaration.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS for company vehicles. +€4.80 / vehicle / month.",
    "vehicles": "Vehicles"
  },
  "users": {
    "title": "How many users do you need?",
    "help": "Every person using Done-it counts as one user, including administrators and employees.",
    "active": "users"
  },
  "estimate": "Estimated monthly cost",
  "estimateNote": "Excluding VAT. You pay for the number of users you set here, and you can change it later.",
  "estimateUnavailable": "Price catalog unavailable. Retry to load the latest pricing."
}
